import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { fontSize, gridSize } from '@atlaskit/theme/constants';
import { getColors } from './colors';
var gridSizeUnit = gridSize();
var height = gridSize() * 3 / fontSize();
var separator = '"/"';
export var getStyles = function getStyles(mode) {
  var colors = getColors(mode);
  return {
    margin: 0,
    padding: 0,
    color: colors.separatorColor,
    display: 'flex',
    flexWrap: 'wrap',
    '&>li:not(:last-child)::after': {
      content: "".concat(separator),
      flexShrink: 0,
      padding: "0 ".concat(gridSizeUnit, "px"),
      textAlign: 'center',
      width: "".concat(gridSizeUnit, "px")
    }
  };
};
export var itemWrapperStyles = {
  display: 'flex',
  flexDirection: 'row',
  height: "".concat(height, "em"),
  lineHeight: "".concat(height, "em"),
  margin: 0,
  padding: 0,
  boxSizing: 'border-box',
  maxWidth: '100%'
};
export var itemStyles = function itemStyles(truncationWidth) {
  var fontWeight = {
    fontWeight: 400
  };
  return truncationWidth ? _objectSpread(_objectSpread({}, fontWeight), {}, {
    maxWidth: "".concat(truncationWidth, "px !important")
  }) : _objectSpread(_objectSpread({}, fontWeight), {}, {
    flexShrink: 1,
    minWidth: 0
  });
};